export const SearchParam = {
  Tag: "tag",
  Assignee: "assignee",
  Contact: "contact",
  DueDate: "due_date",
  ShowCompleted: "show_completed",
  Query: "q",
  Task: "task",
  Page: "p",
  GraphNode: "node",
  Actor: "actor",
  EntityType: "entity_type",
  Welcome: "welcome",
  ReturnTo: "return_to",
  Upgrade: "upgrade",
  Severity: "severity",
  InsightType: "type",
  Stack: "stack",
} as const;

/** Opens pricing on the current page. Replaces the page's other search params. */
export const upgradeHref = `?${SearchParam.Upgrade}=`;

/**
 * Where to send someone back after login when an authed page kicked them to
 * /login. Only in-app paths pass, anything resolving outside our origin
 * falls back to "/".
 */
export function safeReturnTo(raw: string | null, fallback = "/") {
  if (raw == null) return fallback;
  try {
    const url = new URL(raw, window.location.origin);
    return url.origin === window.location.origin
      ? url.pathname + url.search + url.hash
      : fallback;
  } catch {
    return fallback;
  }
}
